import { Box } from "@mui/material";
import { useNavigate } from "react-router";

import NotificationCardWrapper from "../NotificationCardWrapper";
import Info from "../../../../media/svg/Info";
import CustomAvatar from "../../CustomAvatar";

const HotTableNotificationSummary = ({ data }) => {
  const navigate = useNavigate();
  return (
    <Box onClick={() => navigate(`/table/${data.target.pk}`)}>
      <NotificationCardWrapper
        firstChild={<Info />}
        seccondChild={
          <Box>
            <b>{data?.title}</b> is a hot table, do you want to enroll in that?
          </Box>
        }
        ThirdChild={
          <CustomAvatar
            size={48}
            src={data?.actor.banner}
            alt={data?.actor.banner}
            borderSize={1.5}
            round={"8px"}
          />
        }
      />
    </Box>
  );
};

export default HotTableNotificationSummary;
